import { createSelector } from "reselect";

export const INIT_SUFFIX = '_copy';

function getCreatives(state){
	return state.creatives.items;
}

function getSelected(state){
	return state.selected.creatives;
}

function compileCreatives(creatives, selected){
	if(selected.length === 0 || creatives.length === 0){ return creatives; }

	return creatives.map((v) => {
		let isSelected = false;

		if(selected.indexOf(v.id) > -1){
			isSelected = true;
		}

		return {
			...v,
			isSelected,
		};
	});
}

function matchSelectedCreatives(compare, exact) {
	return (creatives, selected) => {
		if (selected.length === 0 || creatives.length === 0) { return [];}

		const matches = creatives.filter((creative) => {
			return selected.indexOf(creative.id) >= 0 && compare(creative);
		});

		if (exact && matches.length !== selected.length) {
			return [];
		}

		return matches;
	};
}

export const buildSelectedCreativesList = createSelector([getCreatives, getSelected], compileCreatives);
/**
 * Returns a subset of the selected creatives based on the `compare` func. May use `exact` to only return matches if all selected
 * creatives pass the comparison.
 * @param   {function(creative): boolean}   compare     The comparison you are looking to match (e.g. isDynamic).
 * @param   {boolean}                       exact       Require exact match, where all selected must match your criteria.
 * @returns {Object[]}   Creatives that pass the comparison function.
 */
export const selectedCreativesByMatch = (compare, exact = false) => (
	createSelector([getCreatives, getSelected], matchSelectedCreatives(compare, exact))
);

export function hasVersionsSelector(state){
	return state.creativeDetails?.numberOfVersions > 1;
}

export const PRIVATE = {
	getSelected,
	getCreatives,
	compileCreatives,
	matchSelectedCreatives,
};
